import { createApp } from '@app/adapters/create-app'
import MainView from '../screens/prepare/components/main-view.vue'
import MainHeader from '../screens/prepare/components/main-header.vue'
import createMeetingPreparationStore from '@app/application/client_meetings/screens/prepare/stores/main'
import MainSidebar from '@app/application/client_meetings/screens/prepare/components/main-sidebar/main-sidebar.vue'
import { getSafeJSONValue } from '@app/utils/local-storage'
import { useDrawer } from '@app/shared/pinia/drawer'
import { RightDrawerContent } from '@app/shared/types/drawer'

function handleDrawerReady() {
  window.eventHub.$off('drawer:ready', handleDrawerReady)

  const drawerStore = useDrawer()

  const showSidebarSetting = getSafeJSONValue('showMeetingPreparationSidebar')

  const showSidebar =
    showSidebarSetting === null || showSidebarSetting === undefined
      ? true
      : showSidebarSetting

  if (showSidebar) {
    drawerStore.openRightDrawer(RightDrawerContent.TPSuggestions, true)
  } else {
    drawerStore.closeRightDrawerWithoutPersisting()
  }
}

onDomLoad(function ($dom) {
  const dataElement = document.getElementById(
    'page-data/client-meetings/prepare'
  )

  if (!dataElement) {
    return
  }

  const pageData = JSON.parse(dataElement.textContent)

  let store

  $dom.find("[data-behaviour='client-meetings-preparation']").each(function () {
    store = createMeetingPreparationStore({
      firmId: Silverfin.currentFirmId,
      companyId: Silverfin.currentCompanyId,
    })

    const app = createApp(MainView)

    app.provide('pageData', pageData)
    app.use(store)

    app.mount(this)
  })

  $dom
    .find("[data-behaviour='client-meetings-preparation-header']")
    .each(function () {
      window.eventHub.$on('drawer:ready', handleDrawerReady)
      const app = createApp(MainHeader)

      app.provide('pageData', pageData)
      app.use(store)

      app.mount(this)
    })

  $dom.find("[data-behaviour='client-meetings-suggestions']").each(function () {
    const app = createApp(MainSidebar)
    app.provide('pageData', pageData)
    app.use(store)
    app.mount(this)
  })
})
